import { object, array, number, SchemaOf, boolean, StringSchema } from 'yup';

import { DockerSecurityFormValues } from './types';

export function createDockerSecurityValidationSchema(
  nameValidation: StringSchema<string>
): SchemaOf<DockerSecurityFormValues> {
  return object({
    name: nameValidation,
    environmentGroupIds: array(number().required()),
    allowBindMountsForRegularUsers: boolean().required(),
    allowPrivilegedModeForRegularUsers: boolean().required(),
    allowHostNamespaceForRegularUsers: boolean().required(),
    allowDeviceMappingForRegularUsers: boolean().required(),
    allowStackManagementForRegularUsers: boolean().required(),
    allowContainerCapabilitiesForRegularUsers: boolean().required(),
    allowSysctlSettingForRegularUsers: boolean().required(),
  });
}
